module.exports = __webpack_public_path__ + "static/media/iTOVi_DNA_Icon.663a9360.png";